// Import model
import { RoomPhotoFile } from '../models/RoomPhotoFile';

// Import base class serializer
import { ObjectFileSerializer } from './ObjectFileSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for RoomPhotoFile - handles JSON serialization and deserialization with type validation
 */
export class RoomPhotoFileSerializer {
  /**
   * Deserializes a JSON string into a RoomPhotoFile instance
   */
  static deserialize(json: string): RoomPhotoFile {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a RoomPhotoFile instance
   */
  static fromObject(obj: any): RoomPhotoFile {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to RoomPhotoFile');
    }


    const instance: RoomPhotoFile = {
      contentType: obj['contentType'] as string | undefined,
      size: obj['size'] as number | undefined,
      publicUrl: obj['publicUrl'] as string | undefined,
      allowAnonymousDownload: obj['allowAnonymousDownload'] as boolean | undefined,
      flowId: obj['flowId'] as string | undefined,
      flowIdName: obj['flowId|Name'] as string | undefined,
      objectStatusId: obj['objectStatusId'] as string | undefined,
      objectStatusIdName: obj['objectStatusId|Name'] as string | undefined,
      t: obj['_t'] as string | undefined,
      name: obj['name'] as string | undefined,
      uri: obj['uri'] as string | undefined,
      parentId: obj['parentId'] as string | undefined,
      parentIdName: obj['parentId|Name'] as string | undefined,
      creatorId: obj['creatorId'] as string | undefined,
      creatorIdName: obj['creatorId|Name'] as string | undefined,
      description: obj['description'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      entityIdName: obj['entityId|Name'] as string | undefined,
      id: obj['_id'] as string | undefined,
      createdDate: obj['createdDate'] as string | undefined,
      parentObjectId: obj['parentObjectId'] as string | undefined,
      parentObjectType: obj['parentObjectType'] as string | undefined,
      e669Ab74: obj['_e669ab74'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of RoomPhotoFile instances
   */
  static deserializeArray(json: string): RoomPhotoFile[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a RoomPhotoFile instance to a JSON string
   */
  static serialize(instance: RoomPhotoFile): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a RoomPhotoFile instance to a plain object
   */
  static toObject(instance: RoomPhotoFile): any {
    return {
      'contentType': instance.contentType,
      'size': instance.size,
      'publicUrl': instance.publicUrl,
      'allowAnonymousDownload': instance.allowAnonymousDownload,
      'flowId': instance.flowId,
      'flowId|Name': instance.flowIdName,
      'objectStatusId': instance.objectStatusId,
      'objectStatusId|Name': instance.objectStatusIdName,
      '_t': instance.t,
      'name': instance.name,
      'uri': instance.uri,
      'parentId': instance.parentId,
      'parentId|Name': instance.parentIdName,
      'creatorId': instance.creatorId,
      'creatorId|Name': instance.creatorIdName,
      'description': instance.description,
      'entityId': instance.entityId,
      'entityId|Name': instance.entityIdName,
      '_id': instance.id,
      'createdDate': instance.createdDate,
      'parentObjectId': instance.parentObjectId,
      'parentObjectType': instance.parentObjectType,
      '_e669ab74': instance.e669Ab74,
    };
  }

  /**
   * Serializes an array of RoomPhotoFile instances to a JSON string
   */
  static serializeArray(instances: RoomPhotoFile[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
